import { Directive, Input, signal } from '@angular/core';
import { BaseComponent } from '@ups/xplat/core';

@Directive()
export abstract class AppsyncStatusBaseComponent extends BaseComponent {
  @Input() color = '#00275d';
  @Input() row = 0;
  status = signal('');
  hasUpdate = signal(false);
}
